module.exports = __webpack_public_path__ + "static/media/lorem-ipsum-generator-light.a0bd5c0e.png";